import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Grid, Icon, Button } from 'semantic-ui-react'
import * as actionCreators from '../actions/DescriptionOfMerchandiseActions'
import CustomCheckBox from '../formComponents/checkBox'
import InputField from '../formComponents/inputField'
import DropDown from '../formComponents/dropDown'
//import {QryFuncModal} from "../../components/qryFunc"
import {QryFuncModal} from 'kx-common-components';
import store from '../store'
import { hasanyvaluesAdcvd } from '../reducer/util'



 
export const hasFieldKN = (stringInput) => {
  if(stringInput == -999)return false; 
  if(stringInput == "_BLANK_")return false;
  if(stringInput == "N/A")return false;
  return !!((stringInput||"")+"").trim();
}

class AVCVDSection extends Component {


  constructor(props) {
    super(props)

    this.state = {
      showthisad: false,
      showthiscvd: false,
      adcvd: {},
      openPane_gg: false || this.props.formDisabled,
      currentDuty: {}
    }
  }

 componentWillMount(){
    var currentDuty = {}
    if(this.props.mystate){
      for(var oneduty of this.props.currentLineItem.merchandiseDuties){
        if(oneduty.isCommodityDuty == 1){
          currentDuty=oneduty;
        }
      }
    }
    this.setState({currentDuty:currentDuty})
    if(this.props.adcvd){
      this.setState({adcvd: currentDuty.adcvd})
    }
    setTimeout(()=>{
      this.setState(this.state); 
    },1010);

 }

 selectCase(qryParams) {
   /*
adValoremRate: "370.04"
caseNo: "A570075000"
cashBondIndicator: "C

   {"caseData":{
    //adValoremRate 
    "caseNo":"A570075002","manufacturerName":"NINGBO JUNLONG CRAFT GIFT CO., LTD.","detail":
   {"records":[{"recordId":"RA","name":"RA : General Case Info","description":"The RA-Record returns basic 
   information concerning the AD/CVD case.","values":[{"key":"companyCaseStatus","value":"AC"},{"key":"countryCode","value":"CN"},
   */
   let caseNo = qryParams.caseData.caseNo;
   let isAD = (caseNo.charAt(0).toLowerCase() == "a");
  //  adValoremRate
  //  cashBondIndicator
   
   let mytype = (isAD)?'ad':'cvd';

    let oldadcvd = this.props.adcvd || {};
    if(!oldadcvd[mytype]){
      oldadcvd[mytype] = {
        caseNo: caseNo,
        caseDepositRate: qryParams.caseData.adValoremRate,
        claimCode: qryParams.caseData.cashBondIndicator,
        caseRateCode: 'A'
      }
    }else{
      oldadcvd[mytype].caseNo = caseNo;
      oldadcvd[mytype].caseDepositRate = qryParams.caseData.adValoremRate;
      oldadcvd[mytype].claimCode = qryParams.caseData.cashBondIndicator;
      oldadcvd[mytype].caseRateCode = 'A';
    }
    
    this.setState({adcvd:oldadcvd});
    this.updatemystatem(mytype+'.caseNo',oldadcvd[mytype].caseNo,true,this.props.lineItemIndex , this.props.invoiceItemIndex)
    this.updatemystatem(mytype+'.caseDepositRate',oldadcvd[mytype].caseDepositRate,true,this.props.lineItemIndex , this.props.invoiceItemIndex)
    this.updatemystatem(mytype+'.claimCode',oldadcvd[mytype].claimCode,true,this.props.lineItemIndex , this.props.invoiceItemIndex)
    this.updatemystatem(mytype+'.caseRateCode',oldadcvd[mytype].caseRateCode,true,this.props.lineItemIndex , this.props.invoiceItemIndex)

 }

 toggleSetState(){
    this.props.validateFormzz(true);
    // this.setState({openPane_gg:!this.state.openPane_gg,openPane_ggToggled:true});
    this.forceUpdate();
 }
 updatemystatem(field, payload, saveafterwards,lineItemIndex, invoiceItemIndex){
  // if(typeof payload == 'object')return; 

  const {
    merchandiseId,
  } = this.props
  this.props.updateAVCDVDField(field, payload, saveafterwards,lineItemIndex,invoiceItemIndex ,this.props.shipmentId,
    merchandiseId);
  // var newstate = this.props.adcvd || {ad:{},cvd:{}};
  // var mysplitfield = field.split(".");
  // if(mysplitfield.length == 1){
  //   newstate[mysplitfield[0]]=payload;
  // }
  // if(mysplitfield.length == 2){
  //   newstate[mysplitfield[0]][mysplitfield[1]]=payload;

  // }
  // if(mysplitfield.length == 3){
  //   newstate[mysplitfield[0]][mysplitfield[1]][mysplitfield[2]]=payload;

  // }
  // this.setState({adcvd: newstate});

    
 }



  render() {
    // const {
    //   pgaRuling,
    //   lineItemIndex,
    //   merchandiseId,
    //   updateMerchLineItemPgaObject,
    //   formDisabled,
    //   expandAll
    // } = this.props
    // const { activeAccordianIndex } = this.state
    const {
        //saveMerchandiseObject,
        //updatemystatem,
        // sameAs,
        // manufacturerSameAsShipper,
        index,
        penClicked,
        lineItemIndex,
        formDisabled,
        merchandiseId,
        setINPUTID,
        newValue,
        fieldName,
        shipmentId,
        rbCounterID,
        currentLineItem,
        mystate,
        invoiceItemIndex,
        manufacturerHeaderIdUnderPartiesTab,
        headerParties,
        voluntaryAdcvdAdd,
        voluntaryAdcvdClear
      } = this.props
      
      let mylocaladcvdval = this.props.adcvd || {ad:{},cvd:{}};
      if(!mylocaladcvdval.ad)mylocaladcvdval.ad ={}
      if(!mylocaladcvdval.cvd)mylocaladcvdval.cvd ={}
      
      
        
      var warningListyy =(store.getState().FieldValidation.validObjects_bl[merchandiseId] && 
        store.getState().FieldValidation.validObjects_bl[merchandiseId].warningListyy) || [];

      let countryOfOrigin = currentLineItem.countryOfOrigin;

      let manufacturerId = (headerParties.filter((a)=>a.headerId==manufacturerHeaderIdUnderPartiesTab).pop()||{}).mId


    let clearcurrentADCVD = (adorcvd)=>{
        setTimeout(() => {
          this.updatemystatem(adorcvd, {
            caseNo: "_BLANK_",
            caseRateCode: "_BLANK_",
            // specialQuantity: "-999",
          }, true, lineItemIndex, invoiceItemIndex)
          setTimeout(() => {
            this.updatemystatem(adorcvd, {
              caseDepositRate: "-999",
              dutyAmount: "-999",
              claimCode: "_BLANK_",
              // specialValue: "-999"
            }, true, lineItemIndex, invoiceItemIndex)
          }, 400*(adorcvd=="cvd"?2:1))
        }, 600*(adorcvd=="cvd"?2:1));
    }

    let aderror = [];

    if (hasanyvaluesAdcvd(mylocaladcvdval, 'ad')) {
      if (!((mylocaladcvdval.ad.caseNo + '').match(/^[aA]\d{9}$/))) {
        aderror.push('Antidumping case number should be \'A\' followed by 9 numbers');
      }
      if (!hasFieldKN(mylocaladcvdval.ad.claimCode)) {
        aderror.push('Missing ad claim code');
      }
      if (!hasFieldKN(mylocaladcvdval.ad.caseRateCode)) {
        aderror.push('Missing ad case rate code');
      }

    }

    let cvderror = [];
    if (hasanyvaluesAdcvd(mylocaladcvdval, 'cvd')) {
      if (!(mylocaladcvdval.cvd.caseNo + '').match(/^[Cc]\d{9}$/)) {
        cvderror.push('Countervailing case number should be \'C\' followed by 9 numbers');
      }
      if (!hasFieldKN(mylocaladcvdval.cvd.claimCode)) {
        cvderror.push('Missing cvd claim code');
      }
      if (!hasFieldKN(mylocaladcvdval.cvd.caseRateCode)) {
        cvderror.push('Missing cvd case rate code');
      }
    }


    let voluntaryPGAsUnfilled = !!(this.props.voluntaryAdcvdAdd && (!hasanyvaluesAdcvd(mylocaladcvdval,'cvd') && !hasanyvaluesAdcvd(mylocaladcvdval,'ad')));


    let anyErrorsInAdcvd = voluntaryPGAsUnfilled || cvderror?.length || aderror?.length;
    let adCvdIsApplied = this.props.voluntaryAdcvdAdd || mylocaladcvdval.adcvdNotApplicable  != '1';

    let expandedAdcvdYes = true;//this.state.openPane_gg || (!this.state.openPane_ggToggled && this.props.manualAdcvdButtonClickedThisSession)

    const adCvdIsDisclaimed = mylocaladcvdval.adcvdNotApplicable  == '1';
    return (
      
      <div
      key={index}
      className={'accordian-section tab-content pga-container adcvd-formstyle' + (formDisabled?' disabled ':'')
      }
    >
      <div
        className='title' style={{fontWeight:"normal", cursor:'auto'}}
         onClick={() => {
           this.toggleSetState()
         }}
      >
          <table style={{ width: "100%" }}><tbody><tr><td style={{ width: '70px' }}>
            {voluntaryAdcvdAdd && <div style={{ display: 'inline-block',width:'2.5rem',height:'1.5rem',textAlign:'center' }}
              onClick={(event) => {
                if (Boolean(formDisabled)) return;
                event.stopPropagation();
                if (!window.confirm("Delete voluntary AD/CVD?")) return;
                clearcurrentADCVD('ad')
                setTimeout(() => {
                  clearcurrentADCVD('cvd')
                  voluntaryAdcvdClear && voluntaryAdcvdClear();
                }, 1000)
              }}


            >
              <Icon
                name='trash alternate outline'
                disabled={Boolean(formDisabled)}
              />
            </div>
            }
        <span >
           {((warningListyy.length == 0 && !anyErrorsInAdcvd && 
           
           (hasanyvaluesAdcvd(mylocaladcvdval,'ad') || hasanyvaluesAdcvd(mylocaladcvdval,'cvd')) 
           && adCvdIsApplied) || !adCvdIsApplied ) ? (
            <Icon name='check circle' className='done-pga' />
          ) : (<Icon name='warning sign' className='undone-pga' />)} 
        </span>
        </td><td>
        <b>AD/CVD {voluntaryAdcvdAdd?'voluntarily added':'may apply'}</b>.<br/>
        {/*expandedAdcvdYes &&*/ <>
        {/* <b>
        	AD/CVD voluntarily added.
          	AD/CVD may apply
        Complete and select DONE to verify
          </b><br/> */}
          {voluntaryAdcvdAdd?'':<>
          (The <b>HTS code</b>, <b>Country of Origin</b> and <b>Manufacturer</b> may trigger AD/CVD duties.)
          </>}
        </>}
        </td></tr></tbody></table>
      </div>
        <div className="total-box"  style={{width:"100%",marginBottom:"10px"}}>
          {voluntaryAdcvdAdd ?
          null
          :
          <CustomCheckBox
                      className='electronic-cert-text'
                      label='AD/CVD not applicable'
                      value={mylocaladcvdval.adcvdNotApplicable  == '1'}
                      disabled={Boolean(formDisabled)}
                      areyousureConfirmationDialogue={true}
                      update={value => {

                        if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                          this.props.updateFormState("adcvdNotApplicable", (value == '1' ? '2' : '1'), "merchandiseDuties.duties", 0)
                          return;
                        }
                        // if((mylocaladcvdval.adcvdNotApplicable != '1') && !window.confirm("Are you sure you want to disclaim AD/CVD?"))return;
                        this.setState({openPane_gg:!(mylocaladcvdval.adcvdNotApplicable != '1'),openPane_ggToggled:true});
                        if(mylocaladcvdval.adcvdNotApplicable != '1' ) {
                          clearcurrentADCVD('ad')
                          clearcurrentADCVD('cvd')
                        }
                        this.updatemystatem(
                          'adcvdNotApplicable',
                          mylocaladcvdval.adcvdNotApplicable == '1' ? '2' : '1',
                          true,
                          lineItemIndex , invoiceItemIndex)
                        
                      }}
                      // onClick={value => {
                      //   this.updatemystatem(
                      //     'adcvdNotApplicable',
                      //     mylocaladcvdval.adcvdNotApplicable == '1' ? '2' : '1',
                      //     true,
                      //     lineItemIndex , invoiceItemIndex)
                        
                      // }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
  }
                    {/*CUSTOMS QUERIES */}
                    <div className="uUiil ADCVDbutton broker-top-header" ><QryFuncModal 
                        brokerId={this.props.brokerId || window.brokerId}
                        launchFrom={'ESForm'}
                        selectCase={this.selectCase.bind(this)}
                        ADCVD_HTS={this.state.currentDuty.htsus}
                        ADCVD_MID={manufacturerId}
                        ADCVD_CO={countryOfOrigin}
                        buttontext="AD/CVD Query"
                        recentQryCall={false}
                        baseUrl={window._env_.REACT_APP_BROKER_API_URL}
                    /></div>
                  </div>






      <div className={'simpleTable' + (expandedAdcvdYes?' showit ':' hideit ')}>


      <br/>
      {!adCvdIsDisclaimed &&<>
{this.state.showthisad  || hasanyvaluesAdcvd(mylocaladcvdval,'ad') ? <React.Fragment>{/*start ad*/}
      <small>ANTI-DUMPING DUTIES APPLIED</small>
      <Icon
        name="trash alternate outline"
        onClick={() => {
          clearcurrentADCVD('ad')
          this.setState({ showthisad: false })
        }}
        title="Clear all antidumping fields"
        disabled={Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
      />
      <React.Fragment>
        <Grid width='equal' className='blk4 line-items'>
          <Grid.Row className="noBottomBorders">
          
          <Grid.Column  width={'4'} className={"noRightBorders"}>
              <InputField
                  placeholder='A123456789'
                  id={`${lineItemIndex}ad.caseNo`}
                  disabled={Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
                  type={'text'}
                  className={'field-bg'}
                  label={'CASE NUMBER'}
                  value={mylocaladcvdval.ad.caseNo || ''}
                //  isInteger={true}
                  handleFocus={e => {
                    e.target.select()
                  }}
                  onChange={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("ad.caseNo", value, "merchandiseDuties.duties[0].adCvd", 0)
                      return;
                    }
                    this.updatemystatem('ad.caseNo',value,false,lineItemIndex, invoiceItemIndex)
                  }}
                  onBlur={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                     return;
                    }
                    this.updatemystatem('ad.caseNo',value,true,lineItemIndex , invoiceItemIndex)
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
          </Grid.Column >
          <Grid.Column className='firstCol no-field-margin dropdowncontainer' width={'4'}>
              <DropDown
                  subLabelClass='left-icon'
                  id={`${lineItemIndex}ad.claimCode`}
                  disabled={Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
                  type={'text'}
                  className={'field-bg'}
                  label={'BOND/CASH CLAIM CODE'}
                  errors={!mylocaladcvdval.ad.claimCode?["Missing claim code"]:null}
                  data={[{description: "Surety Bond covers the duty amount",ediCode: "B",id: "B"}, {description: "Cash Deposit covers duty amount",ediCode: "C",id: "C"}]}
                  text={(mylocaladcvdval.ad.claimCode=="B"?"B - Surety Bond":"") +
                  (mylocaladcvdval.ad.claimCode=="C"?"C - Cash Deposit":"")
                }
              //    isInteger={true}
                  handleFocus={e => {
                    e.target.select()
                  }}
                  onChange={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("ad.claimCode", value, "merchandiseDuties.duties[0].adCvd", 0)
                      return;
                    }
                    this.updatemystatem('ad.claimCode',value,true,lineItemIndex , invoiceItemIndex)
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
          </Grid.Column >
          
          <Grid.Column className='firstCol no-field-margin noBorderRadius noRightBorders' width={'3'}>
              <InputField
                  subLabelText=''
                  subLabelClass='left-icon'
                  id={`${lineItemIndex}ad.caseDepositRate`}
                  disabled={Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
                  type={'text'}
                  className={'field-bg'}
                  label={'CASE DEPOSIT RATE'}
                  value={mylocaladcvdval.ad.caseDepositRate || '' }
                  isInteger={true}
                  handleFocus={e => {
                    e.target.select()
                  }}
                  onChange={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("ad.caseDepositRate", value, "merchandiseDuties.duties[0].adCvd", 0)
                      return;
                    }
                    this.updatemystatem('ad.caseDepositRate',value,false,lineItemIndex , invoiceItemIndex)
                  }}
                  onBlur={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      return;
                    }
                    this.updatemystatem('ad.caseDepositRate',value,true,lineItemIndex , invoiceItemIndex)
                    //saveMerchandiseObject(lineItemIndex, 'ad.caseDepositRate')
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
          </Grid.Column >
        
        <Grid.Column className='no-field-margin dropdowncontainer two' width={'5'}>
              <DropDown
                  subLabelClass='left-icon'
                  id={`${lineItemIndex}ad.caseRateCode`}
                  disabled={Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
                  type={'text'}
                  className={'field-bg'}
                  label={'QUALIFIER CODE'}
                  value={mylocaladcvdval.ad.caseRateCode || ''}
                  errors={!mylocaladcvdval.ad.caseRateCode?["Missing case rate code"]:null}
                  isInteger={true}
                  data={[{description: "Ad Valorem rate",ediCode: "A",id: "A"}, {description: "Specific Rate",ediCode: "S",id: "S"}]}
              //    value={mylocaladcvdval.ad.caseRateCode || 'B'}
                  text={(mylocaladcvdval.ad.caseRateCode=="A"?"A - Ad Valorem":"") +
                    (mylocaladcvdval.ad.caseRateCode=="S"?"S - Specific rate":"")
                  }
                  handleFocus={e => {
                    e.target.select()
                  }}
                  onChange={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("ad.caseRateCode", value, "merchandiseDuties.duties[0].adCvd", 0)
                      return;
                    }
                    this.updatemystatem('ad.caseRateCode',value,true,lineItemIndex , invoiceItemIndex)
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
          </Grid.Column >
        </Grid.Row>
          <Grid.Row className="noBottomBorders">


          
          <Grid.Column className='firstCol no-field-margin noBorderRadius noRightBorders' width={'8'}>
              <InputField
                  subLabelText='$'
                  subLabelClass='left-icon'
                  id={`${lineItemIndex}ad.specialValue`}
                  disabled={true || Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
                  type={'text'}
                  className={'field-bg'}
                  label={'AD SPECIAL VALUE'}
                  value={mylocaladcvdval.ad.specialValue || ''}
                  isInteger={true}
                  handleFocus={e => {
                    e.target.select()
                  }}
                  onChange={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("ad.specialValue", value, "merchandiseDuties.duties[0].adCvd", 0)
                      return;
                    }
                    this.updatemystatem('ad.specialValue',value,false,lineItemIndex , invoiceItemIndex)
                  }}
                  onBlur={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      return;
                    }
                    this.updatemystatem('ad.specialValue',value,true,lineItemIndex , invoiceItemIndex)
                    //saveMerchandiseObject(lineItemIndex, 'ad.specialValue')
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
          </Grid.Column >
          
          <Grid.Column className='firstCol no-field-margin noBorderRadius noRightBorders' width={'3'}>
              <InputField
                  subLabelClass='left-icon'
                  id={`${lineItemIndex}ad.specialQuantity`}
                  disabled={true || Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
                  type={'text'}
                  className={'field-bg'}
                  label={'AD SPL. QUANTY'}
                  value={mylocaladcvdval.ad.specialQuantity || ''}
                  isInteger={true}
                  handleFocus={e => {
                    e.target.select()
                  }}
                  onChange={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("ad.specialQuantity", value, "merchandiseDuties.duties[0].adCvd", 0)
                      return;
                    }
                    this.updatemystatem('ad.specialQuantity',value,false,lineItemIndex , invoiceItemIndex)
                  }}
                  onBlur={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      return;
                    }
                    this.updatemystatem('ad.specialQuantity',value,true,lineItemIndex , invoiceItemIndex)
                    //saveMerchandiseObject(lineItemIndex, 'ad.specialQuantity')
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
          </Grid.Column >
          
          <Grid.Column className='firstCol no-field-margin noBorderRadius' width={'5'}>
              <InputField
                  subLabelText='$'
                  subLabelClass='left-icon'
                  id={`${lineItemIndex}ad.dutyAmount`}
                  disabled={Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
                  type={'text'}
                  className={'field-bg'}
                  label={'AD DUTY AMOUNT'}
                  value={mylocaladcvdval.ad.dutyAmount || ''}
                  isInteger={true}
                  handleFocus={e => {
                    e.target.select()
                  }}
                  onChange={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("ad.dutyAmount", value, "merchandiseDuties.duties[0].adCvd", 0)
                      return;
                    }
                    this.updatemystatem('ad.dutyAmount',value,false,lineItemIndex , invoiceItemIndex)
                  }}
                  onBlur={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      return;
                    }
                    this.updatemystatem('ad.dutyAmount',value,true,lineItemIndex , invoiceItemIndex)
                    //saveMerchandiseObject(lineItemIndex, 'ad.dutyAmount')
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
          </Grid.Column >
          </Grid.Row>
          <Grid.Row>
            <Grid.Column  className='firstCol no-field-margin' width={'16'}>
              <div
              style={{border: '1px solid', borderRadius:'0px 0px 3px 3px'}}
                  className={'field-bg form-control'+((Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1')?' disabled ':' ')}>

                <CustomCheckBox
                  className='electronic-cert-text'
                  label='AD Case Non-reimbursement declaration'
                  value={mylocaladcvdval.ad.nonRiembursementDeclaration  == '1'}
                  disabled={Boolean(formDisabled)}
                  update={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("ad.nonRiembursementDeclaration", (value == '1' ? '2' : '1'), "merchandiseDuties.duties[0].adCvd", 0)
                      return;
                    }
                    this.updatemystatem(
                      'ad.nonRiembursementDeclaration',
                      mylocaladcvdval.ad.nonRiembursementDeclaration == '1' ? '2' : '1',
                      true,
                      lineItemIndex ,invoiceItemIndex)
                    
                  }}
                  onClick={value => {
                    this.updatemystatem(
                      'ad.nonRiembursementDeclaration',
                      mylocaladcvdval.ad.nonRiembursementDeclaration == '1' ? '2' : '1',
                      true,
                      lineItemIndex , invoiceItemIndex)
                    
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
              </div>
            </Grid.Column >

          </Grid.Row>
          </Grid>

                              </React.Fragment>
</React.Fragment>
:<React.Fragment>
            <Button
              className={"add-line-item-btn add-invoice-line-item rectangle"}
              basic
              color="blue"
              // circular
              // compact
              onClick={() => {
                this.setState({ showthisad: true })
              }}
              disabled={Boolean(formDisabled)}
            >
              <span>
                <Icon name="add circle" /> Add Anti-Dumping information
              </span>
            </Button>

</React.Fragment>}

<br/><br/>
</>}{/*end ad*/}

  
  {!adCvdIsDisclaimed &&<>
{this.state.showthiscvd || hasanyvaluesAdcvd(mylocaladcvdval,'cvd') ? <React.Fragment>{/*start cvd*/}
<small>COUNTERVAILING DUTIES APPLIED</small>
<Icon
  name="trash alternate outline"
  title="Clear all countervailing fields"
  onClick={() => {
    clearcurrentADCVD('cvd')
    this.setState({ showthiscvd: false })
  }}
  disabled={Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
/>
<React.Fragment>
        <Grid width='equal' className='blk4 line-items'>
          <Grid.Row className="noBottomBorders">
          
          <Grid.Column  width={'4'} className={"noRightBorders"} >
              <InputField
                  placeholder='C123456789'
                  id={`${lineItemIndex}cvd.caseNo`}
                  disabled={Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
                  type={'text'}
                  className={'field-bg'}
                  label={'CASE NUMBER'}
                  value={mylocaladcvdval.cvd.caseNo || ''}
           //       isInteger={true}
                  handleFocus={e => {
                    e.target.select()
                  }}
                  onChange={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("cvd.caseNo", value, "merchandiseDuties.duties[0].adCvd", 0)
                      return;
                    }
                    this.updatemystatem('cvd.caseNo',value,false,lineItemIndex , invoiceItemIndex)
                  }}
                  onBlur={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                     return;
                    }
                    this.updatemystatem('cvd.caseNo',value,true,lineItemIndex , invoiceItemIndex)
                    //saveMerchandiseObject(lineItemIndex, 'cvd.caseNo')
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
          </Grid.Column >
          
          <Grid.Column className='firstCol no-field-margin dropdowncontainer' width={'4'}>
              <DropDown
                  subLabelClass='left-icon'
                  id={`${lineItemIndex}cvd.claimCode`}
                  disabled={Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
                  type={'text'}
                  className={'field-bg'}
                  label={'BOND/CASH CLAIM CODE'}
                  errors={!mylocaladcvdval.cvd.claimCode?["Missing claim code"]:null}
                  data={[{description: "Surety Bond covers the duty amount",ediCode: "B",id: "B"}, {description: "Cash Deposit covers duty amount",ediCode: "C",id: "C"}]}
              //    value={mylocaladcvdval.cvd.claimCode || 'B'}
                  text={(mylocaladcvdval.cvd.claimCode=="B"?"B - Surety Bond":"") +
                  (mylocaladcvdval.cvd.claimCode=="C"?"C - Cash Deposit":"")
                }
              //    isInteger={true}
                  handleFocus={e => {
                    e.target.select()
                  }}
                  onChange={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("cvd.claimCode", value, "merchandiseDuties.duties[0].adCvd", 0)
                      return;
                    }
                    this.updatemystatem('cvd.claimCode',value,true,lineItemIndex ,invoiceItemIndex)
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
          </Grid.Column >
          
          <Grid.Column className='firstCol no-field-margin noBorderRadius noRightBorders' width={'3'}>
              <InputField
                  subLabelText=''
                  subLabelClass='left-icon'
                  id={`${lineItemIndex}cvd.caseDepositRate`}
                  disabled={Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
                  type={'text'}
                  className={'field-bg'}
                  label={'CASE DEPOSIT RATE'}
                  value={mylocaladcvdval.cvd.caseDepositRate || ''}
                  isInteger={true}
                  handleFocus={e => {
                    e.target.select()
                  }}
                  onChange={value => {
                    this.updatemystatem('cvd.caseDepositRate',value,false,lineItemIndex ,invoiceItemIndex)
                  }}
                  onBlur={value => {
                    this.updatemystatem('cvd.caseDepositRate',value,true,lineItemIndex ,invoiceItemIndex)
                    //saveMerchandiseObject(lineItemIndex, 'cvd.caseDepositRate')
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
          </Grid.Column >
        
        <Grid.Column className='no-field-margin dropdowncontainer two' width={'5'}>
              <DropDown
                  subLabelClass='left-icon'
                  id={`${lineItemIndex}cvd.caseRateCode`}
                  disabled={Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
                  type={'text'}
                  className={'field-bg'}
                  label={'QUALIFIER CODE'}
                  errors={!mylocaladcvdval.cvd.caseRateCode?["Missing case rate code"]:null}
                  data={[{description: "Ad Valorem rate",ediCode: "A",id: "A"}, {description: "Specific Rate",ediCode: "S",id: "S"}]}
                  text={(mylocaladcvdval.cvd.caseRateCode=="A"?"A - Ad Valorem":"") +
                    (mylocaladcvdval.cvd.caseRateCode=="S"?"S - Specific rate":"")
                  }
                  isInteger={true}
                  handleFocus={e => {
                    e.target.select()
                  }}
                  onChange={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("cvd.caseRateCode", value, "merchandiseDuties.duties[0].adCvd", 0)
                      return;
                    }
                    this.updatemystatem('cvd.caseRateCode',value,true,lineItemIndex ,invoiceItemIndex)
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
          </Grid.Column >
        </Grid.Row>
          <Grid.Row>


          
          <Grid.Column className='firstCol no-field-margin noRightBorders' width={'8'}>
              <InputField
                  subLabelText='$'
                  subLabelClass='left-icon'
                  id={`${lineItemIndex}cvd.specialValue`}
                  disabled={true || Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
                  type={'text'}
                  className={'field-bg'}
                  label={'CVD SPECIAL VALUE'}
                  value={mylocaladcvdval.cvd.specialValue || ''}
                  isInteger={true}
                  handleFocus={e => {
                    e.target.select()
                  }}
                  onChange={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("cvd.specialValue", value, "merchandiseDuties.duties[0].adCvd", 0)
                      return;
                    }
                    this.updatemystatem('cvd.specialValue',value,false,lineItemIndex ,invoiceItemIndex)
                  }}
                  onBlur={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      return;
                    }
                    this.updatemystatem('cvd.specialValue',value,true,lineItemIndex ,invoiceItemIndex)
                    //saveMerchandiseObject(lineItemIndex, 'cvd.specialValue')
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
          </Grid.Column >
          
          <Grid.Column className='firstCol no-field-margin noBorderRadius noRightBorders' width={'3'}>
              <InputField
                  subLabelClass='left-icon'
                  id={`${lineItemIndex}cvd.specialQuantity`}
                  disabled={true || Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
                  type={'text'}
                  className={'field-bg'}
                  label={'CVD SPL. QUANTY'}
                  value={mylocaladcvdval.cvd.specialQuantity || ''}
                  isInteger={true}
                  handleFocus={e => {
                    e.target.select()
                  }}
                  onChange={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("cvd.specialQuantity", value, "merchandiseDuties.duties[0].adCvd", 0)
                      return;
                    }
                    this.updatemystatem('cvd.specialQuantity',value,false,lineItemIndex ,invoiceItemIndex)
                  }}
                  onBlur={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      return;
                    }
                    this.updatemystatem('cvd.specialQuantity',value,true,lineItemIndex ,invoiceItemIndex)
                    //saveMerchandiseObject(lineItemIndex, 'cvd.specialQuantity')
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
          </Grid.Column >
          
          <Grid.Column className='firstCol no-field-margin' width={'5'}>
              <InputField
                  subLabelText='$'
                  subLabelClass='left-icon'
                  id={`${lineItemIndex}cvd.dutyAmount`}
                  disabled={Boolean(formDisabled) || mylocaladcvdval.adcvdNotApplicable == '1'}
                  type={'text'}
                  className={'field-bg'}
                  label={'CVD DUTY AMOUNT'}
                  value={mylocaladcvdval.cvd.dutyAmount || ''}
                  isInteger={true}
                  handleFocus={e => {
                    e.target.select()
                  }}
                  onChange={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      this.props.updateFormState("cvd.dutyAmount", value, "merchandiseDuties.duties[0].adCvd", 0)
                      return;
                    }
                    this.updatemystatem('cvd.dutyAmount',value,false,lineItemIndex ,invoiceItemIndex)
                  }}
                  onBlur={value => {
                    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
                      return;
                    }
                    this.updatemystatem('cvd.dutyAmount',value,true,lineItemIndex ,invoiceItemIndex)
                    //saveMerchandiseObject(lineItemIndex, 'cvd.dutyAmount')
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
          </Grid.Column >
          </Grid.Row>
          </Grid>
                              </React.Fragment>
                              {/*end cvd*/}</React.Fragment>
                            
          :<React.Fragment>
          <Button
          className={"add-line-item-btn add-invoice-line-item rectangle"}
          basic
          color="blue"
          // circular
          // compact
          onClick={() => {
            this.setState({ showthiscvd: true })
          }}
          disabled={Boolean(formDisabled)}
        >
          <span>
            <Icon name="add circle" /> Add Countervailing information
          </span>
        </Button>
                            </React.Fragment>}</>}
<div style={{height:"10px"}}>
            {/* {mylocaladcvdval.adcvdNotApplicable  != '2' && warningListyy.map((warningga,itttt)=>{
              return <React.Fragment key={itttt}>{
                itttt < 4 && 
                <div style={{float:'left',marginRight:'20px',padding:'1px',border:"1px solid #eee"}}>{warningga}</div>
              }
            </React.Fragment>}
            )

            } */}
            </div>
            {(cvderror||[]).map(onerror=> <div className="error" key={onerror}>{onerror}</div>)}
            {(aderror||[]).map(onerror=> <div className="error" key={onerror}>{onerror}</div>)}
            {voluntaryPGAsUnfilled && <div className="error">Voluntary AD/CVD must have an AD or CVD</div>}
            {/* <Button 
          onClick={() => {
            if(anyErrorsInAdcvd)return;
            this.toggleSetState()
          }}
            
            className={`ui button save-pga-button ${(anyErrorsInAdcvd)?' disabled ':' '}`}>DONE</Button> */}

          </div>{/*-- end simpletable --*/}
          

        </div>
    )
  }
}


const mapStateToProps = (state, props) => {
    return {
    //   adcvdNotApplicable: props.adcvdNotApplicable,

    //   adcasNo: state.DescriptionOfMerchandise.merchandiseLineItems[props.lineItemIndex].commercialDescription,
    //   adbond: state.DescriptionOfMerchandise.merchandiseLineItems[props.lineItemIndex].countryOfOrigin,
    //   adcaseDepositRate: state.DescriptionOfMerchandise.merchandiseLineItems[props.lineItemIndex].productClaimCode,
    //   adcaseRateCode: state.DropDownValues.countryList,
    //   adspecialValue: state.DropDownValues.userFeeCodes,
    //   adspecialQuantity: state.DropDownValues.USStatesList,
    //   addutyAmount: state.DropDownValues.splProgramList,

      
    //   cvdcasNo: state.DescriptionOfMerchandise.merchandiseLineItems[props.lineItemIndex].commercialDescription,
    invoiceItemIndex: props.invoiceItemIndex,
       currentLineItem: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex],
       manufacturerHeaderIdUnderPartiesTab: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex].manufacturerHeaderIdUnderPartiesTab,
       headerParties: state.Importer.headerParties,
    //   cvdcaseDepositRate: state.DescriptionOfMerchandise.merchandiseLineItems[props.lineItemIndex].productClaimCode,
    //   cvdcaseRateCode: state.DropDownValues.countryList,
    //   cvdspecialValue: state.DropDownValues.userFeeCodes,
    //   cvdspecialQuantity: state.DropDownValues.USStatesList,
    //   cvddutyAmount: state.DropDownValues.splProgramList,

    //   signDate: new Date().getTime()
    }
  }

const mapDispatchToProps = {
  ...actionCreators
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AVCVDSection)